import { Button, Flex, Heading, Stack, Text, VStack } from '@chakra-ui/react'

import { pluralize } from '@/utils/helpers'

import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'
import { getExploreUrl } from '@/client/services/url'

import { QUERY_LIMIT_MAX } from '@/components/Session/helpers'
import SessionRow from '@/components/Session/SessionRow'
import ShwLink from '@/components/ShwLink'

const SessionList: React.FC<{
  sessions: Query[]
  totalItemsCount: number
  limit: number
  hideHeader?: boolean
  hideFooter?: boolean
  onLoadMore: () => void
  showAllPath: string
}> = ({
  sessions,
  totalItemsCount,
  limit,
  onLoadMore,
  hideHeader = false,
  hideFooter = false,
  showAllPath,
}) => (
  <>
    {hideHeader ? null : (
      <Text color="fg.muted" mt="40px" mb="16px" fontWeight={600}>
        {pluralize(totalItemsCount, 'Session')}
      </Text>
    )}
    <Stack direction="column" spacing="24px" mb="24px">
      {sessions.map(session => (
        <SessionRow key={session(SessionQ.id) ?? 0} session={session} entrypoint />
      ))}
    </Stack>
    {totalItemsCount === 0 ? <Text>This tutor has no upcoming sessions at the moment.</Text> : null}
    <Flex justifyContent="center">
      {totalItemsCount > limit && limit < QUERY_LIMIT_MAX ? (
        <>
          <Button variant="outline" minWidth="150px" onClick={onLoadMore}>
            See More
          </Button>
          <noscript>
            <Button as="a" variant="outline" minWidth="150px" href={showAllPath}>
              See All
            </Button>
          </noscript>
        </>
      ) : hideFooter ? null : (
        <VStack spacing="24px" width="500px" my="32px">
          <Heading size="xl" as="h3" textAlign="center">
            That&apos;s it for now!
          </Heading>
          <Text textAlign="center">
            Don&apos;t see what you need? Check again later, or{' '}
            <ShwLink href={getExploreUrl()}>find a subworld</ShwLink> that works for you!
          </Text>
        </VStack>
      )}
    </Flex>
  </>
)

export default SessionList
